// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3bWN6","header":"PatientQuestionnaire_header__3gTKu","info":"PatientQuestionnaire_info__13IGc"};